import type { IDeclaration } from '../types';
import type { Step } from './Step';

export class Form {
  public guid: string;
  public declaration: IDeclaration | null = null;
  public acceptPaymentTermsAndConditions: boolean = false;
  public steps: Step[] = [];

  constructor(guid: string) {
    this.guid = guid;
  }
}
